/* =========================================================
   Ambassador Reviews — video playback

   The block image is the only media rendered on load. The video
   (Shopify-hosted or an embed) sits in a <template> and is mounted
   on the first click of the play button, so the poster is always
   the merchant's image and nothing loads until it is asked for.
   Without JS the image simply stays put.
   ========================================================= */

class AmbassadorVideo extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('[data-ar-play]');
    this.template = this.querySelector('[data-ar-template]');
    this.host = this.querySelector('[data-ar-media]');

    if (!this.trigger || !this.template || !this.host) return;

    this.trigger.addEventListener('click', this.play.bind(this));
  }

  play() {
    if (this.playing) return;
    this.playing = true;

    const media = this.template.content.firstElementChild;
    if (!media) return;

    this.host.appendChild(media.cloneNode(true));
    this.setAttribute('data-playing', '');

    // Shopify-hosted videos mount paused; the click is the user gesture
    // that lets them start with sound.
    const native = this.host.querySelector('video');
    if (native && typeof native.play === 'function') {
      const started = native.play();
      if (started && typeof started.catch === 'function') {
        started.catch(() => {
          // Autoplay refused — the controls are already visible.
        });
      }
    }
  }
}

if (!customElements.get('ambassador-video')) {
  customElements.define('ambassador-video', AmbassadorVideo);
}